import { render, staticRenderFns } from "./OnlineBiddingNotice.vue?vue&type=template&id=462b9403&scoped=true&"
import script from "./OnlineBiddingNotice.vue?vue&type=script&lang=js&"
export * from "./OnlineBiddingNotice.vue?vue&type=script&lang=js&"
import style0 from "./OnlineBiddingNotice.vue?vue&type=style&index=0&id=462b9403&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462b9403",
  null
  
)

export default component.exports